import { useState } from "react";
import axios from "axios";
import { pollChatJob } from "../../lib/chatJob";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useGptJob = (owner) => {
  const [state, setState] = useState(null);
  const run = async (body) => {
    setState({ loading: true });
    try {
      const t = localStorage.getItem("apex_token");
      const r = await axios.post(`${API}/portfolio-engine/ai/${owner}`, body, {
        headers: t ? { Authorization: `Bearer ${t}` } : {},
      });
      const j = await pollChatJob(owner, r.data.job_id);
      setState({ reply: j.reply });
    } catch (e) {
      setState({ error: e?.response?.data?.detail || e.message });
    }
  };
  return [state, run];
};
